const middleware = {}

middleware['ageGate'] = require('../middleware/ageGate.js')
middleware['ageGate'] = middleware['ageGate'].default || middleware['ageGate']

export default middleware
